import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/src/reducers/types';

import { UpdatedTaskStatusEnum } from '@/src/components/task/Config';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';

// @TODO: update statuses
const taskStatusClassnames = {
  [UpdatedTaskStatusEnum.Todo]: 'tw-text-cfo-green-300 tw-bg-cfo-green-100',
  [UpdatedTaskStatusEnum.ToApprove]: 'tw-text-cfo-blue-600 tw-bg-cfo-yellow-100',
  [UpdatedTaskStatusEnum.ToReview]: 'tw-text-cfo-yellow-400 tw-bg-cfo-yellow-100',
  [UpdatedTaskStatusEnum.Completed]: 'tw-text-cfo-blue-600 tw-bg-cfo-blue-200',
  [UpdatedTaskStatusEnum.ChangeRequested]: 'tw-text-cfo-yellow-400 tw-bg-cfo-yellow-100',
  [UpdatedTaskStatusEnum.Approved]: 'tw-text-cfo-black tw-bg-cfo-blue-200',
  [UpdatedTaskStatusEnum.Delayed]: 'tw-text-cfo-red-400 tw-bg-cfo-red-100',
};

const TaskStatusPill = ({
  status,
  className = '',
  style = {},
  isCalendar = false,
  isMilestone,
  hasReport,
  isDashboard,
  task,
}: {
  status?: string;
  className?: string;
  style?: React.CSSProperties;
  isCalendar?: boolean;
  isMilestone?: boolean;
  hasReport?: boolean;
  isDashboard?: boolean;
  task?: {
    assigneeId?: number;
    approverId?: number;
    reviewerId?: number;
  };
}) => {
  const loggedUser = useSelector((store: RootState) => store.loggedUser);
  let statusText = UpdatedTaskStatusEnum[status] || status;

  if (isDashboard && task && loggedUser?.data?.id) {
    const userId = loggedUser.data.id;
    // To Approve/For Approval logic
    if (status === 'To Approve' && task.assigneeId === userId) {
      statusText = 'For Approval';
    } else if (status === 'For Approval' && task.approverId === userId) {
      statusText = 'To Approve';
    }
    // To Review/For Review logic
    else if (status === 'To Review' && task.assigneeId === userId) {
      statusText = 'For Review';
    } else if (status === 'For Review' && task.reviewerId === userId) {
      statusText = 'To Review';
    }
  }
  const statusClass = taskStatusClassnames[status];

  return (
    <div className="tw-flex tw-gap-1">
      {!isMilestone && !hasReport && (
        <div
          className={clsx([
            'tw-text-center tw-font-brandonTextMedium  tw-rounded-[24px] tw-py-1 tw-px-[6px]',
            !isCalendar && 'tw-min-w-[120px] tw-w-[120px]',
            isDashboard && 'tw-text-sm',
            statusClass,
            className,
          ])}
          style={style}
        >
          {statusText}
        </div>
      )}
      {isMilestone && (
        <div
          className={clsx(
            'tw-text-center tw-font-brandonTextMedium tw-rounded-[24px] tw-py-1 tw-px-[6px] tw-bg-cfo-blue-100 tw-text-cfo-blue-600 tw-text-[18px]',
            !isCalendar && 'tw-min-w-[90px] tw-w-[90px]'
          )}
          style={style}
        >
          <Icon icon={ICONS.flag} className="tw-text-[18px]" />
        </div>
      )}
      {hasReport && (
        <div
          className={clsx(
            'tw-text-center tw-font-brandonTextMedium tw-rounded-[8px] tw-px-[0.5rem] tw-py-[0.25rem] tw-bg-cfo-blue-200 tw-text-cfo-blue-600',
            !isCalendar && 'tw-min-w-[70px] tw-w-[70px]'
          )}
          style={style}
        >
          Reports
        </div>
      )}
    </div>
  );
};

export default TaskStatusPill;
